import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatNavList } from '@angular/material/list';
import { ActivatedRoute, RouterModule } from '@angular/router';
import {
  PartnerActionsComponent,
  PartnerStatusComponent,
} from '@principle-theorem/ng-principle';
import {
  BreadcrumbsComponent,
  type IBreadcrumb,
  NgSharedModule,
} from '@principle-theorem/ng-shared';
import { Partner } from '@principle-theorem/principle-core';
import {
  type IPartner,
  type IUser,
} from '@principle-theorem/principle-core/interfaces';
import {
  all$,
  type CollectionReference,
  doc$,
  filterUndefined,
  findProp,
  HISTORY_DATE_FORMAT,
  type WithRef,
} from '@principle-theorem/shared';
import { sortBy } from 'lodash';
import { type Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'pr-partner-edit',
  templateUrl: './partner-edit.component.html',
  styleUrls: ['./partner-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    BreadcrumbsComponent,
    PartnerStatusComponent,
    PartnerActionsComponent,
    NgSharedModule,
    MatNavList,
    RouterModule,
  ],
})
export class PartnerEditComponent {
  breadcrumbs$: Observable<IBreadcrumb[]>;
  partner$: Observable<WithRef<IPartner>>;
  users$: Observable<WithRef<IUser>[]>;
  userCollection$: Observable<CollectionReference<IUser>>;
  readonly dateFormat = HISTORY_DATE_FORMAT;

  constructor(private _route: ActivatedRoute) {
    this.partner$ = this._route.data.pipe(
      findProp<WithRef<IPartner>>('partner'),
      filterUndefined(),
      switchMap((partner) => doc$(partner.ref))
    );

    this.breadcrumbs$ = this.partner$.pipe(
      map((partner) => [
        { label: 'Partners', path: '../' },
        { label: partner.name },
      ])
    );

    this.userCollection$ = this.partner$.pipe(
      filterUndefined(),
      map((partner) => Partner.userCol(partner))
    );

    this.users$ = this.userCollection$.pipe(
      switchMap((collection) => all$(collection)),
      map((users) => sortBy(users, 'name'))
    );
  }

  getRegions(partner: WithRef<IPartner>): string {
    return partner.regions.join(', ');
  }
}
